import { render, staticRenderFns } from "./myWorksheets.vue?vue&type=template&id=4e5cf49c&scoped=true"
import script from "./myWorksheets.vue?vue&type=script&lang=js"
export * from "./myWorksheets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5cf49c",
  null
  
)

export default component.exports